var $22195056771860be$exports = {};
$22195056771860be$exports = {
  "rangeUnderflow": function rangeUnderflow(args) {
    return "Value must be ".concat(args.minValue, " or later.");
  },
  "rangeOverflow": function rangeOverflow(args) {
    return "Value must be ".concat(args.maxValue, " or earlier.");
  },
  "rangeReversed": "Start date must be before end date.",
  "unavailableDate": "Selected date unavailable."
};
export { $22195056771860be$exports as default };